import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getPictureByKey, getUnionModule, getUnionActivity } from '@/views/custom-layout/api';
export default {
  name: 'saas_long_image_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      rules: {
        type: [{
          required: true,
          message: '请选择头部配置方式',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '名称不可为空',
          trigger: 'change'
        }, {
          min: 1,
          max: 10,
          message: '字数应大于等于1个字符小于10个字符!',
          trigger: 'change'
        }],
        header_image: [{
          required: true,
          message: '头部图片不可为空',
          trigger: 'change'
        }],
        bg_color: [{
          required: true,
          message: '背景色不可为空',
          trigger: 'change'
        }],
        data_source_type: [{
          required: true,
          message: '请选择数据来源模式',
          trigger: 'change'
        }],
        activity_num: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!/^[0-9]*$/.test(value)) {
              callback('仅支持正整数');
            } else if (value > 99 || value < 1) {
              callback('仅支持1-99正整数');
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      },
      moduleList: [],
      icon: 'https://res.youlianfuwu.com/mini_program/answer/ask_activity_pic.jpg',
      showPictureLibrary: false,
      pictureList: [],
      depot: {},
      updateIndex: 0,
      commonValue: {
        module_id: '',
        module_type: '',
        open_module_type: '',
        module_plate_id: '',
        // 板块ID
        module_activity_id: '',
        // 活动ID
        swipe_image: ''
      },
      activityListOfModule: {} // 记录每个板块对应的活动列表
    };
  },
  methods: {
    getActivityList: function getActivityList(module_plate_id) {
      var activityList = this.activityListOfModule[module_plate_id];
      return activityList || [];
    },
    addUpload: function addUpload() {
      this.value.config.value.push(_objectSpread({}, this.commonValue));
    },
    handleDelUpload: function handleDelUpload(index) {
      var _this = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this.value.config.value.splice(index, 1);
      }).catch(function () {});
    },
    changeActivity: function changeActivity(activity_id, item) {
      var activityList = this.getActivityList(item.module_plate_id) || [];
      var activityData = activityList.find(function (i) {
        return i.module_activity_id === activity_id;
      });
      if (activityData) {
        this.$set(item, 'swipe_image', activityData.swipe_image);
      }
    },
    changeModule: function changeModule(module_plate_id, configData) {
      var _this2 = this;
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return new Promise(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve) {
          var data, module_id, module_type, open_module_type, _props$module_activit, module_activity_id;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                data = _this2.moduleList.find(function (i) {
                  return i.id === module_plate_id;
                });
                if (data) {
                  module_id = data.module_id, module_type = data.module_type, open_module_type = data.open_module_type;
                  configData.module_id = module_id;
                  configData.module_type = module_type;
                  configData.open_module_type = open_module_type;
                }
                if (!(_this2.value.config.data_source_type === 2)) {
                  _context.n = 1;
                  break;
                }
                _props$module_activit = props.module_activity_id, module_activity_id = _props$module_activit === void 0 ? '' : _props$module_activit;
                configData.module_activity_id = module_activity_id;
                // 独立数据源模式下，获取对应板块的活动列表
                if (!(module_plate_id && data && data.is_have_child && !_this2.activityListOfModule[module_plate_id])) {
                  _context.n = 1;
                  break;
                }
                _context.n = 1;
                return getUnionActivity({
                  module_plate_id: module_plate_id,
                  customer_id: _this2.info.customer_id
                }, module).then(function (res) {
                  _this2.$set(_this2.activityListOfModule, module_plate_id, res.data);
                });
              case 1:
                resolve();
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getUnionModuleList: function getUnionModuleList() {
      var _this3 = this;
      // 获取SaaS板块下拉数据
      var _this$info = this.info,
        customer_id = _this$info.customer_id,
        module = _this$info.module;
      return getUnionModule({
        customer_id: customer_id
      }, module).then(function (res) {
        _this3.moduleList = res.data;
      });
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this4 = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this4.pictureList = picture[1] || [];
        _this4.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config.value[this.updateIndex]['swipe_image'] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(index) {
      if (typeof index === 'number') {
        this.$refs.uploadBanner[index].uploadBanner();
        return;
      }
      this.$refs.uploadBanner.uploadBanner();
    },
    emitUploadFile: function emitUploadFile(url, index) {
      if (typeof index === 'number') {
        this.$set(this.value.config.value[index], 'swipe_image', "".concat(this.$ossurl).concat(url));
        return;
      }
      this.$set(this.value.config, 'header_image', "".concat(this.$ossurl).concat(url));
    },
    onDelete: function onDelete() {
      var _this5 = this;
      if (!this.value.config.header_image) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this5.$set(_this5.value.config, 'header_image', '');
      });
    }
  },
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _this6$value$config$v, value, valueData, i, item;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _this6.getPicture();
            _context2.n = 1;
            return _this6.getUnionModuleList();
          case 1:
            _this6$value$config$v = _this6.value.config.value, value = _this6$value$config$v === void 0 ? [] : _this6$value$config$v;
            if (!(value.length < 1)) {
              _context2.n = 2;
              break;
            }
            // 默认预置3个活动
            valueData = Array.from({
              length: 3
            }, function () {
              return _objectSpread({}, _this6.commonValue);
            });
            _this6.$set(_this6.value.config, 'value', valueData);
            _context2.n = 5;
            break;
          case 2:
            i = 0;
          case 3:
            if (!(i < _this6.value.config.value.length)) {
              _context2.n = 5;
              break;
            }
            item = _this6.value.config.value[i];
            _context2.n = 4;
            return _this6.changeModule(item.module_plate_id, item, {
              module_activity_id: item.module_activity_id
            });
          case 4:
            i++;
            _context2.n = 3;
            break;
          case 5:
            _this6.$set(_this6.value, 'config', _objectSpread({
              type: '1',
              name: '',
              header_image: '',
              bg_color: '#ffffff',
              module_id: '',
              module_type: '',
              open_module_type: '',
              module_plate_id: '',
              activity_num: 5,
              margin_top: 15,
              //兼容新老组件 默认预置15px
              z_index: 2,
              //兼容新老组件 默认预置2
              data_source_type: 1,
              //兼容新老组件 默认预置1
              value: [],
              is_check_user: 0
            }, JSON.parse(JSON.stringify(_this6.value.config))));
          case 6:
            return _context2.a(2);
        }
      }, _callee2);
    }))();
  }
};